<div class="privacy-container">
  @if (trustedHtml()) {
    <div class="ql-editor" [innerHTML]="trustedHtml()"></div>
  } @else {
    <h1>Privacy Policy</h1>
    <p>Last Updated 1/1/2026</p>
    <p>We may share Your personal information in the following situations:</p>
    <ul>
      <li>
        <strong>With Service Providers:</strong>
        We may share Your personal information with Service Providers to monitor and analyze the use
        of our Service, for payment processing, to contact You.
      </li>
      <li>
        <strong>For business transfers:</strong>
        We may share or transfer Your personal information in connection with, or during
        negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a
        portion of Our business to another company.
      </li>
      <li>
        <strong>With business partners:</strong>
        We may share Your information with Our business partners to offer You certain products,
        services or promotions.
      </li>
      <li>
        <strong>With other users:</strong>
        when You share personal information or otherwise interact in the public areas with other
        users, such information may be viewed by all users and may be publicly distributed outside.
        If You interact with other users or register through a Third-Party Social Media Service,
        Your contacts on the Third-Party Social Media Service may see Your name, profile, pictures
        and description of Your activity. Similarly, other users will be able to view descriptions
        of Your activity, communicate with You and view Your profile.
      </li>
      <li>
        <strong>With Your consent:</strong>
        We may disclose Your personal information for any other purpose with Your consent.
      </li>
    </ul>

    <h2>Interpretation and Definitions</h2>

    <h3>Email Marketing</h3>
    <p>
      We may use Your Personal Data to contact You with newsletters, marketing or promotional
      materials and other information that may be of interest to You. You may opt-out of receiving
      any, or all, of these communications from Us by following the unsubscribe link or instructions
      provided in any email We send or by contacting Us.
    </p>

    <h3>Payments</h3>
    <p>
      We may provide paid products and/or services within the Service. In that case, we may use
      third-party services for payment processing (e.g. payment processors).
    </p>
    <p>
      We will not store or collect Your payment card details. That information is provided directly
      to Our third-party payment processors whose use of Your personal information is governed by
      their Privacy Policy. These payment processors adhere to the standards set by PCI-DSS as
      managed by the PCI Security Standards Council, which is a joint effort of brands like Visa,
      Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure
      handling of payment information.
    </p>

    <h2>Stripe</h2>

    <p>
      Our data is processed by Stripe in accordance with
      <a href="https://stripe.com/privacy">Stripe's Privacy Policy</a>
      for all payments.
    </p>

    <h2>Exercising Your CCPA Data Protection Rights</h2>
    <p>
      In order to exercise any of Your rights under the CCPA, and if You are a California resident,
      You can contact Us:
    </p>
    <p>
      By email:
      <a href="mailto:info@singleservemerch.com">info&#64;singleservemerch.com</a>
    </p>
    <p>
      By visiting this page on our website:
      <a href="https://singleservemerch.com/#ssm-contact-section" target="_blank">
        https://singleservemerch.com/#ssm-contact-section
      </a>
    </p>
  }
</div>
